import {DropdownMenu} from '@wandb/components';
import React from 'react';

import {keyString} from '../../../util/runs';
import type {RunKeySection} from '../../../util/runTypes';
import {replaceColumnAggregation} from '../../../util/tablecols';
import {useSetTableSettings} from '../RunSelectorTableSettingsContext';
import type {WBTableColumn} from '../WBTable/types';
import {MenuItem} from './MenuItem';

export function columnMightHaveAggregations(column: WBTableColumn) {
  const section = column.key.section;

  return (
    section === 'summary' ||
    section === 'aggregations_max' ||
    section === 'aggregations_min'
  );
}

type AggregationGroupProps = {
  column: WBTableColumn;
  isDisabled?: boolean;
};

export function AggregationGroup({column, isDisabled}: AggregationGroupProps) {
  const setTableSettings = useSetTableSettings();
  let currentValue: 'latest' | 'min' | 'max' = 'latest';
  if (column.key.section === 'aggregations_min') {
    currentValue = 'min';
  } else if (column.key.section === 'aggregations_max') {
    currentValue = 'max';
  }

  function handleSelectionChange(keys: 'all' | Set<React.Key>) {
    if (keys === 'all') {
      return;
    }
    const key = [...keys][0] as string | undefined;
    if (!key) {
      return;
    }
    let newSection: RunKeySection = 'summary';
    if (key === 'min') {
      newSection = 'aggregations_min';
    } else if (key === 'max') {
      newSection = 'aggregations_max';
    }
    const newAccessor = keyString(newSection, column.key.name);
    setTableSettings(s =>
      replaceColumnAggregation(s, column.accessor, newAccessor)
    );
  }

  return (
    <DropdownMenu.SubTrigger>
      <MenuItem icon="x-axi-alt" isDisabled={isDisabled}>
        Show {currentValue}
      </MenuItem>
      <DropdownMenu.Content>
        <DropdownMenu.Section
          selectedKeys={[currentValue]}
          selectionMode="single"
          onSelectionChange={handleSelectionChange}>
          <MenuItem id="latest">Latest</MenuItem>
          <MenuItem id="min">Min</MenuItem>
          <MenuItem id="max">Max</MenuItem>
        </DropdownMenu.Section>
      </DropdownMenu.Content>
    </DropdownMenu.SubTrigger>
  );
}
